import React from 'react';

import { Card, Col, Row } from 'antd-v5';
import { FormattedHTMLMessage } from 'react-intl';

import { ProgramLogo } from '@context/components';
import { S } from '@shared/components';

import styles from './ReferencesPage.less';
import { refrencesDetails } from './constants';

export const ReferencesPage = () => {
  const handleNewTab = (link: string) => {
    window.open(`${link}`, '_blank'); // "_blank" opens in new tab
  };

  return (
    <div className={styles.container}>
      <Card>
        <Row align={'middle'} justify={'center'}>
          {refrencesDetails.map(ref => (
            <Col key={ref.value} className={styles.btnContainer} span="24">
              <div
                className={styles.refButton}
                onClick={() => handleNewTab(ref.link)}
              >
                <ProgramLogo program={ref.programId} />
                <S className={styles.refButtonLabel}>
                  <S colored>
                    <FormattedHTMLMessage
                      id={`shared.references.${ref.value}`}
                    />
                  </S>
                </S>
              </div>
            </Col>
          ))}
        </Row>
      </Card>
    </div>
  );
};
